enum Ethnicities {
    Abenaki = 1,
    AbsenteeShawnee,
    Acoma,
    Afghanistani,
    African,
    AfricanAmerican,
    Agdaagux,
    AguaCaliente,
    AguaCalienteCahuilla,
    Ahtna,
    AkChin,
    Akhiok,
    Akiachak,
    Akiak,
    Akutan,
    AlabamaCoushatta,
    AlabamaCreek,
    AlabamaQuassarte,
    Alakanuk,
    AlamoNavajo,
    Alanvik,
    AlaskaIndian,
    AlaskaNative,
    AlaskanAthabascan,
    Alatna,
    Aleknagik,
    Aleut,
    AleutCorporation,
    Aleutian,
    AleutianIslander,
    Alexander,
    Algonquian,
    Allakaket,
    AllenCanyon,
    Alpine,
    Alsea,
    AlutiiqAleut,
    Ambler,
    AmericanIndian,
    AmericanIndianorAlaskaNative,
    Anaktuvuk,
    AnaktuvukPass,
    Andreafsky,
    Angoon,
    Aniak,
    Anvik,
    Apache,
    Arab,
    Arapaho,
    Arctic,
    ArcticSlopeCorporation,
    ArcticSlopeInupiat,
    Arikara,
    ArizonaTewa,
    Armenian,
    Aroostook,
    Asian,
    AsianIndian,
    Assiniboine,
    AssiniboineSioux,
    Assyrian,
    Atka,
    Atmautluak,
    Atqasuk,
    Atsina,
    Attacapa,
    Augustine,
    BadRiver,
    Bahamian,
    Bangladeshi,
    Bannock,
    Barbadian,
    BarrioLibre,
    Barrow,
    BattleMountain,
    BayMillsChippewa,
    Beaver,
    Belkofski,
    BeringStraitsInupiat,
    Bethel,
    Bhutanese,
    BigCypress,
    BillMooresSlough,
    Biloxi,
    BirchCreek,
    Bishop,
    Black,
    BlackorAfricanAmerican,
    Blackfeet,
    BlackfootSioux,
    BoisForte,
    Botswanan,
    BrevigMission,
    Bridgeport,
    Brighton,
    BristolBayAleut,
    BristolBayYupik,
    Brotherton,
    BruleSioux,
    Buckland,
    Burmese,
    BurnsPaiute,
    BurtLakeBand,
    BurtLakeChippewa,
    BurtLakeOttawa,
    Cabazon,
    Caddo,
    Cahto,
    Cahuilla,
    CaliforniaTribes,
    CalistaYupik,
    Cambodian,
    Campo,
    CanadianandLatinAmericanIndian,
    CanadianIndian,
    CanoncitoNavajo,
    Cantwell,
    CapitanGrande,
    Carolinian,
    Carson,
    Catawba,
    Cayuga,
    Cayuse,
    Cedarville,
    Celilo,
    CentralAmericanIndian,
    CentralCouncilofTlingitandHaidaTribes,
    CentralPomo,
    Chalkyitsik,
    Chamorro,
    Chefornak,
    Chehalis,
    Chemakuan,
    Chemehuevi,
    Chenega,
    Cherokee,
    CherokeeAlabama,
    CherokeeShawnee,
    CherokeesofNortheastAlabama,
    CherokeesofSoutheastAlabama,
    Chevak,
    Cheyenne,
    CheyenneRiverSioux,
    CheyenneArapaho,
    Chickahominy,
    Chickaloon,
    Chickasaw,
    Chignik,
    ChignikLagoon,
    ChignikLake,
    Chilkat,
    Chilkoot,
    Chimariko,
    Chinese,
    Chinik,
    Chinook,
    Chippewa,
    ChippewaCree,
    Chiricahua,
    Chistochina,
    Chitimacha,
    Chitina,
    Choctaw,
    Chuathbaluk,
    ChugachAleut,
    ChugachCorporation,
    Chukchansi,
    Chumash,
    Chuukese,
    Circle,
    CitizenBandPotawatomi,
    ClarksPoint,
    Clatsop,
    ClearLake,
    CliftonChoctaw,
    CoastMiwok,
    CoastYurok,
    Cochiti,
    Cocopah,
    CoeurDAlene,
    Coharie,
    ColoradoRiver,
    Columbia,
    ColumbiaRiverChinook,
    Colville,
    Comanche,
    CookInlet,
    Coos,
    CoosLowerUmpquaSiuslaw,
    CopperCenter,
    CopperRiver,
    Coquilles,
    Costanoan,
    Council,
    Coushatta,
    CowCreekUmpqua,
    Cowlitz,
    Craig,
    Cree,
    Creek,
    Croatan,
    CrookedCreek,
    Crow,
    CrowCreekSioux,
    Cupeno,
    Cuyapaipe,
    DakotaSioux,
    Deering,
    Delaware,
    Diegueno,
    Digger,
    Dillingham,
    DominicaIslander,
    Dominican,
    DotLake,
    Douglas,
    Doyon,
    Dresslerville,
    DryCreek,
    DuckValley,
    Duckwater,
    Duwamish,
    Eagle,
    EasternCherokee,
    EasternChickahominy,
    EasternCreek,
    EasternDelaware,
    EasternMuscogee,
    EasternPomo,
    EasternShawnee,
    EasternTribes,
    EchotaCherokee,
    Eek,
    Egegik,
    Egyptian,
    Eklutna,
    Ekuk,
    Ekwok,
    Elim,
    Elko,
    Ely,
    Emmonak,
    English,
    EnglishBay,
    Eskimo,
    Esselen,
    Ethiopian,
    EtowahCherokee,
    European,
    Evansville,
    Eyak,
    Fallon,
    FalsePass,
    Fijian,
    Filipino,
    FirstNations,
    FlandreauSantee,
    FloridaSeminole,
    FondduLac,
    ForestCounty,
    FortBelknap,
    FortBerthold,
    FortBidwell,
    FortHall,
    FortIndependence,
    FortMcDermitt,
    FortMcdowell,
    FortPeck,
    FortPeckAssiniboineSioux,
    FortSillApache,
    FortYukon,
    French,
    FrenchAmericanIndian,
    Gabrieleno,
    Gakona,
    Galena,
    Gambell,
    GayHeadWampanoag,
    GeorgetownEasternTribes,
    GeorgetownYupikEskimo,
    German,
    GilaBend,
    GilaRiverPimaMaricopa,
    Golovin,
    GoodnewsBay,
    Goshute,
    GrandPortage,
    GrandRonde,
    GrandTraverseBandofOttawaChippewa,
    Grayling,
    GreenlandEskimo,
    GrosVentres,
    Guamanian,
    GuamanianorChamorro,
    Gulkana,
    Haida,
    Haitian,
    Haliwa,
    Hannahville,
    Havasupai,
    HealyLake,
    Hidatsa,
    Hmong,
    Hochunk,
    Hoh,
    HollywoodSeminole,
    HolyCross,
    Hoonah,
    Hoopa,
    HoopaExtension,
    HooperBay,
    Hopi,
    Houma,
    Hualapai,
    Hughes,
    HuronPotawatomi,
    Huslia,
    Hydaburg,
    Igiugig,
    Iliamna,
    IllinoisMiami,
    InajaCosmit,
    InalikDiomede,
    IndianTownship,
    IndianaMiami,
    Indonesian,
    Inuit,
    Inupiaq,
    InupiatEskimo,
    Iowa,
    IowaofKansasNebraska,
    IowaofOklahoma,
    IowaSacandFox,
    IqurmuitRussianMission,
    Iranian,
    Iraqi,
    Irish,
    Iroquois,
    Isleta,
    Israeili,
    Italian,
    IvanofBay,
    IwoJiman,
    Jamaican,
    Jamestown,
    Japanese,
    Jemez,
    JenaChoctaw,
    JicarillaApache,
    Juaneno,
    Kaibab,
    Kake,
    Kaktovik,
    Kalapuya,
    Kalispel,
    Kalskag,
    Kaltag,
    Karluk,
    Karuk,
    Kasaan,
    Kashia,
    Kasigluk,
    Kathlamet,
    Kaw,
    Kawaiisu,
    Kawerak,
    Kenaitze,
    Keres,
    KernRiver,
    Ketchikan,
    Keweenaw,
    Kialegee,
    Kiana,
    Kickapoo,
    Kikiallus,
    KingCove,
    KingSalmon,
    Kiowa,
    Kipnuk,
    Kiribati,
    Kivalina,
    Klallam,
    Klamath,
    Klawock,
    KlutiKaah,
    Knik,
    Kobuk,
    Kodiak,
    Kokhanok,
    Koliganek,
    Kongiganak,
    KoniagAleut,
    Konkow,
    Kootenai,
    Korean,
    Kosraean,
    Kotlik,
    Kotzebue,
    Koyuk,
    Koyukuk,
    Kwethluk,
    Kwigillingok,
    Kwiguk,
    LaJolla,
    LaPosta,
    LacCourteOreilles,
    LacduFlambeau,
    LacVieuxDesertChippewa,
    Laguna,
    LakeMinchumina,
    LakeSuperior,
    LakeTraverseSioux,
    Laotian,
    LarsenBay,
    LasVegas,
    Lassik,
    Lebanese,
    LeechLake,
    LenniLenape,
    Levelock,
    Liberian,
    Lime,
    LipanApache,
    LittleShellChippewa,
    LonePine,
    LongIsland,
    LosCoyotes,
    Lovelock,
    LowerBruleSioux,
    LowerElwha,
    LowerKalskag,
    LowerMuscogee,
    LowerSioux,
    LowerSkagit,
    Luiseno,
    Lumbee,
    Lummi,
    MachisLowerCreekIndian,
    Maidu,
    Makah,
    Malagasy,
    Malaysian,
    Maldivian,
    MalheurPaiute,
    Maliseet,
    Mandan,
    ManleyHotSprings,
    Manokotak,
    Manzanita,
    MarianaIslander,
    Maricopa,
    Marshall,
    Marshallese,
    MarshantucketPequot,
    MarysIgloo,
    MashpeeWampanoag,
    Matinecock,
    Mattaponi,
    Mattole,
    MaunelukInupiat,
    Mcgrath,
    MdewakantonSioux,
    Mekoryuk,
    Melanesian,
    Menominee,
    MentastaLake,
    MesaGrande,
    MescaleroApache,
    Métis,
    Metlakatla,
    MexicanAmericanIndian,
    Miami,
    Miccosukee,
    MichiganOttawa,
    Micmac,
    Micronesian,
    MiddleEasternorNorthAfrican,
    MilleLacs,
    Miniconjou,
    MinnesotaChippewa,
    Minto,
    MissionIndians,
    MississippiChoctaw,
    MissouriSacandFox,
    Miwok,
    Moapa,
    Modoc,
    Mohave,
    Mohawk,
    Mohegan,
    Molala,
    Mono,
    Montauk,
    Moor,
    Morongo,
    MountainMaidu,
    MountainVillage,
    MowaBandofChoctaw,
    Muckleshoot,
    Munsee,
    Naknek,
    Nambe,
    Namibian,
    NanaInupiat,
    Nansemond,
    Nanticoke,
    Napakiak,
    Napaskiak,
    Napaumute,
    Narragansett,
    Natchez,
    NativeHawaiian,
    NativeHawaiianorOtherPacificIslander,
    NausuWaiwash,
    Navajo,
    NebraskaPonca,
    NebraskaWinnebago,
    NelsonLagoon,
    Nenana,
    Nepalese,
    NewHebrides,
    NewStuyahok,
    Newhalen,
    Newtok,
    NezPerce,
    Nigerian,
    Nightmute,
    Nikolai,
    Nikolski,
    Ninilchik,
    Nipmuc,
    Nishinam,
    Nisqually,
    Noatak,
    Nomalaki,
    Nome,
    Nondalton,
    Nooksack,
    Noorvik,
    NorthernArapaho,
    NorthernCherokee,
    NorthernCheyenne,
    NorthernPaiute,
    NorthernPomo,
    Northway,
    NorthwestTribes,
    Nuiqsut,
    Nulato,
    Nunapitchukv,
    OglalaSioux,
    Okinawan,
    OklahomaApache,
    OklahomaCado,
    OklahomaChoctaw,
    OklahomaComanche,
    OklahomaDelaware,
    OklahomaKickapoo,
    OklahomaKiowa,
    OklahomaMiami,
    OklahomaOttawa,
    OklahomaPawnee,
    OklahomaPeoria,
    OklahomaPonca,
    OklahomaSacandFox,
    OklahomaSeminole,
    OldHarbor,
    Omaha,
    Oneida,
    Onondaga,
    Ontonagon,
    OregonAthabaskan,
    Osage,
    Oscarville,
    OtherEthnicity,
    OtherPacificIslander,
    OtoeMissouria,
    Ottawa,
    Ouzinkie,
    OwensValley,
    Paiute,
    Pakistani,
    Pala,
    Palauan,
    Palestinian,
    Pamunkey,
    Panamint,
    PapuaNewGuinean,
    PascuaYaqui,
    Passamaquoddy,
    Paugussett,
    PauloffHarbor,
    Pauma,
    Pawnee,
    PaysonApache,
    Pechanga,
    PedroBay,
    Pelican,
    Penobscot,
    Peoria,
    Pequot,
    Perryville,
    Petersburg,
    Picuris,
    PilotPoint,
    PilotStation,
    Pima,
    PineRidgeSioux,
    PipestoneSioux,
    Piro,
    Piscataway,
    PitRiver,
    PitkasPoint,
    Platinum,
    PleasantPointPassamaquoddy,
    PoarchBand,
    PocomokeAcohonock,
    Pohnpeian,
    PointHope,
    PointLay,
    Pojoaque,
    PokagonPotawatomi,
    Polish,
    Polynesian,
    Pomo,
    Ponca,
    Poospatuck,
    PortGambleKlallam,
    PortGraham,
    PortHeiden,
    PortLions,
    PortMadison,
    PortageCreek,
    Potawatomi,
    Powhatan,
    PrairieBand,
    PrairieIslandSioux,
    PrincipalCreekIndianNation,
    PriorLakeSioux,
    Pueblo,
    PugetSoundSalish,
    Puyallup,
    PyramidLake,
    QaganToyagungin,
    Qawalangin,
    Quapaw,
    Quechan,
    Quileute,
    Quinault,
    Quinhagak,
    RamahNavajo,
    Rampart,
    RampoughMountain,
    Rappahannock,
    RedCliffChippewa,
    RedDevil,
    RedLakeChippewa,
    RedWood,
    RenoSparks,
    RockyBoysChippewaCree,
    RosebudSioux,
    RoundValley,
    Ruby,
    RubyValley,
    SacandFox,
    SaginawChippewa,
    Saipanese,
    Salamatof,
    Salinan,
    Salish,
    SalishandKootenai,
    SaltRiverPimaMaricopa,
    Samish,
    Samoan,
    SanCarlosApache,
    SanFelipe,
    SanIldefonso,
    SanJuan,
    SanJuanDe,
    SanJuanPueblo,
    SanJuanSouthernPaiute,
    SanManual,
    SanPasqual,
    SanXavier,
    SandHill,
    SandPoint,
    Sandia,
    SansArcSioux,
    SantaAna,
    SantaClara,
    SantaRosa,
    SantaRosaCahuilla,
    SantaYnez,
    SantaYsabel,
    SanteeSioux,
    SantoDomingo,
    SaukSuiattle,
    SaultSteMarieChippewa,
    Savoonga,
    Saxman,
    ScammonBay,
    Schaghticoke,
    ScottValley,
    Scottish,
    ScottsValley,
    Selawik,
    Seldovia,
    Sells,
    Seminole,
    Seneca,
    SenecaNation,
    SenecaCayuga,
    Serrano,
    Setauket,
    Shageluk,
    Shaktoolik,
    Shasta,
    Shawnee,
    SheldonsPoint,
    Shinnecock,
    Shishmaref,
    ShoalwaterBay,
    Shoshone,
    ShoshonePaiute,
    Shungnak,
    SiberianEskimo,
    SiberianYupik,
    Siletz,
    Singaporean,
    Sioux,
    SissetonSioux,
    SissetonWahpeton,
    Sitka,
    Siuslaw,
    Skokomish,
    SkullValley,
    Skykomish,
    Slana,
    Sleetmute,
    Snohomish,
    Snoqualmie,
    Soboba,
    SokoagonChippewa,
    Solomon,
    SolomonIslander,
    SouthAmericanIndian,
    SouthForkShoshone,
    SouthNaknek,
    SoutheastAlaska,
    SoutheasternIndians,
    SouthernArapaho,
    SouthernCheyenne,
    SouthernPaiute,
    SpanishAmericanIndian,
    SpiritLakeSioux,
    Spokane,
    SquaxinIsland,
    SriLankan,
    StCroixChippewa,
    StGeorge,
    StMarys,
    StMichael,
    StPaul,
    StandingRockSioux,
    StarClanofMuscogeeCreeks,
    Stebbins,
    Steilacoom,
    Stevens,
    Stewart,
    Stillaguamish,
    Stockbridge,
    StonyRiver,
    Stonyford,
    Sugpiaq,
    SulphurBank,
    SummitLake,
    Suqpigaq,
    Suquamish,
    Susanville,
    Susquehanock,
    Swinomish,
    Sycuan,
    Syrian,
    TableBluff,
    Tachi,
    Tahitian,
    Taiwanese,
    Takelma,
    Takotna,
    Talakamish,
    Tanacross,
    Tanaina,
    Tanana,
    TananaChiefs,
    Taos,
    Tatitlek,
    Tazlina,
    Telida,
    Teller,
    Temecula,
    TeMoakWesternShoshone,
    TenakeeSprings,
    Tenino,
    Tesuque,
    Tetlin,
    TetonSioux,
    Tewa,
    TexasKickapoo,
    Thai,
    Thlopthlocco,
    Tigua,
    Tillamook,
    TimbiShaShoshone,
    Tlingit,
    TlingitHaida,
    Tobagoan,
    Togiak,
    TohonoOOdham,
    Tok,
    Tokelauan,
    Toksook,
    Tolowa,
    TonawandaSeneca,
    Tongan,
    Tonkawa,
    TorresMartinez,
    Trinidadian,
    Trinity,
    Tsimshian,
    Tuckabachee,
    Tulalip,
    TuleRiver,
    Tulukskak,
    TunicaBiloxi,
    Tuntutuliak,
    Tununak,
    TurtleMountain,
    Tuscarora,
    Tuscola,
    TwentyNinePalms,
    TwinHills,
    TwoKettleSioux,
    Tygh,
    Tyonek,
    Ugashik,
    UintahUte,
    Umatilla,
    Umkumiate,
    Umpqua,
    Unalakleet,
    Unalaska,
    UnanganAleut,
    Unga,
    UnitedKeetowahBandofCherokee,
    UpperChinook,
    UpperSioux,
    UpperSkagit,
    Ute,
    UteMountainUte,
    UtuUtuGwaituPaiute,
    Venetie,
    Vietnamese,
    WaccamawSiousan,
    WahpekuteSioux,
    WahpetonSioux,
    Wailaki,
    Wainwright,
    WakiakumChinook,
    Wales,
    WalkerRiver,
    WallaWalla,
    Wampanoag,
    Wappo,
    WarmSprings,
    Wascopum,
    Washakie,
    Washoe,
    WazhazaSioux,
    Wenatchee,
    WestIndian,
    WesternCherokee,
    WesternChickahominy,
    Whilkut,
    White,
    WhiteEarth,
    WhiteMountain,
    WhiteMountainApache,
    WhiteMountainInupiat,
    Wichita,
    Wicomico,
    WillapaChinook,
    WindRiver,
    WindRiverArapaho,
    WindRiverShoshone,
    Winnebago,
    Winnemucca,
    Wintun,
    WisconsinPotawatomi,
    Wiseman,
    Wishram,
    Wiyot,
    Wrangell,
    Wyandotte,
    Yahooskin,
    Yakama,
    YakamaCowlitz,
    Yakutat,
    Yana,
    YanktonSioux,
    YanktonaiSioux,
    Yapese,
    Yaqui,
    Yavapai,
    YavapaiApache,
    YeringtonPaiute,
    Yokuts,
    Yomba,
    Yuchi,
    Yuki,
    Yuman,
    YupikEskimo,
    Yurok,
    Zairean,
    Zia,
    Zuni,
    Atikamekw
}
export { Ethnicities };
